import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { AuthContext } from "../../components/AuthContext";
import axios from "axios";
import "./WebinarPage.css";
import { BASE_URL } from "../../config/baseUrl";

function WebinarPage() {
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/Webinar`)
      .then((res) => res.json())
      .then((data) => {
        const now = new Date();

        // Upcoming webinars first
        const upcoming = data
          .filter((wb) => {
            const wbDate = new Date(`${wb.startDate.split("T")[0]}T${wb.startTime}`);
            return wbDate >= now && wb.isActive;
          })
          .sort((a, b) => {
            const aDate = new Date(`${a.startDate.split("T")[0]}T${a.startTime}`);
            const bDate = new Date(`${b.startDate.split("T")[0]}T${b.startTime}`);
            return aDate - bDate; // earliest first
          });

        // Completed webinars next
        const completed = data
          .filter((wb) => {
            const wbDate = new Date(`${wb.startDate.split("T")[0]}T${wb.startTime}`);
            return wbDate < now && wb.isActive;
          })
          .sort((a, b) => {
            const aDate = new Date(`${a.startDate.split("T")[0]}T${a.startTime}`);
            const bDate = new Date(`${b.startDate.split("T")[0]}T${b.startTime}`);
            return bDate - aDate; // latest first
          });

        setWebinars([...upcoming, ...completed]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching webinars:", err);
        setLoading(false);
      });
  }, []);

  const formatDateTime = (startDate, startTime) => {
    if (!startDate || !startTime) return "Date not available";
    const parsed = new Date(`${startDate.split("T")[0]}T${startTime}`);
    if (isNaN(parsed)) return "Date not available";
    return parsed.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const isUpcoming = (startDate, startTime) => {
    if (!startDate || !startTime) return false;
    const parsed = new Date(`${startDate.split("T")[0]}T${startTime}`);
    return !isNaN(parsed) && parsed > new Date();
  };

  const handleRegisterClick = async (webinar) => {
    if (!user) {
      navigate("/login");
      return;
    }

    try {
      const enrollData = {
        UserId: user.userId,
        FullName: user.fullName,
        Email: user.email,
        CatalogTypeName: "Webinar",
        CatalogItem: webinar.webinarName
      };

      await axios.post(`${BASE_URL}/EnrollUser`, enrollData);

      alert(`You have successfully registered for "${webinar.webinarName}"! Check your email for confirmation.`);
    } catch (err) {
      console.error(err);
      alert("Error registering for webinar. Please try again.");
    }
  };

  return (
    <>
      <Navbar />

      <section className="webinar-hero d-flex align-items-center">
        <div className="container text-center">
          <h1>📺 Webinars</h1>
          <p>Discover upcoming sessions & rewatch past events</p>
        </div>
      </section>

      <main className="main webinar-page">
        <div className="container">
          {loading ? (
            <p className="loading-text">Loading webinars...</p>
          ) : webinars.length === 0 ? (
            <p className="empty-text">No webinars available at the moment.</p>
          ) : (
            <div className="row">
              {webinars.map((wb) => (
                <div key={wb.webinarId} className="col-lg-4 col-md-6 mb-4">
                  <div className="webinar-card h-100">
                    <div className="thumbnail-wrapper position-relative">
                      <img
                        src={wb.coverImage || "assets/img/webinar-placeholder.jpg"}
                        alt={wb.webinarName}
                        className="img-fluid rounded"
                      />
                      {!isUpcoming(wb.startDate, wb.startTime) && wb.link && (
                        <a
                          href={wb.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="play-overlay"
                          aria-label="Watch recording"
                        >
                          ▶
                        </a>
                      )}
                      {wb.isPaid && (
                        <span className="badge-paid">Paid: ₹{wb.price}</span>
                      )}
                    </div>
                    <div className="p-3">
                      <h4>{wb.webinarName}</h4>
                      <p className="mentor-name">Mentor: {wb.mentorName}</p>
                      <p className="small text-muted">
                        {formatDateTime(wb.startDate, wb.startTime)} ({wb.duration} mins)
                      </p>
                      <p>
                        {wb.description?.length > 100
                          ? wb.description.slice(0, 100) + "..."
                          : wb.description}
                      </p>

                      {isUpcoming(wb.startDate, wb.startTime) ? (
                        <button
                          onClick={() => handleRegisterClick(wb)}
                          className="btn-register-small"
                        >
                          Register
                        </button>
                      ) : wb.link ? (
                        <a
                          href={wb.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-watch-small"
                        >
                          Watch
                        </a>
                      ) : null}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default WebinarPage;
